import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/siteConfig";

// Floating WhatsApp CTA — visible on every public and dashboard page.
// Hidden on print. Positioned bottom-right, with an on-hover tooltip.
export default function WhatsAppButton() {
  const [hover, setHover] = useState(false);
  return (
    <div
      className="fixed bottom-5 right-5 z-[60] print:hidden"
      data-testid="whatsapp-fab"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {hover && (
        <div
          className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap
                     bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-md shadow-lg
                     after:content-[''] after:absolute after:top-1/2 after:-translate-y-1/2 after:right-[-4px]
                     after:border-y-4 after:border-y-transparent after:border-l-4 after:border-l-slate-900"
          data-testid="whatsapp-tooltip"
        >
          Chat With SchoolLane
        </div>
      )}
      <a
        href={COMPANY.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with SchoolLane on WhatsApp"
        data-testid="whatsapp-link"
        className="flex items-center justify-center w-14 h-14 rounded-full
                   bg-[#25D366] text-white shadow-lg
                   hover:bg-[#1EBE57] hover:shadow-xl hover:scale-105
                   focus:outline-none focus:ring-4 focus:ring-emerald-200
                   transition-all duration-200"
      >
        <MessageCircle size={26} strokeWidth={2.2} />
      </a>
    </div>
  );
}
